import { createSelector } from 'reselect'

/**
 * Select the error state slice
 * @param {object} state - Redux state
 * @returns {object} Error state
 */
export const selectErrorState = (state) => state.error

/**
 * Select the current error
 * @param {object} state - Redux state
 * @returns {object|null} Error object
 */
export const selectError = createSelector(
  selectErrorState,
  (errorState) => errorState.error
)

/**
 * Select whether the error modal is visible
 * @param {object} state - Redux state
 * @returns {boolean} Error modal visibility
 */
export const selectShowErrorModal = createSelector(
  selectErrorState,
  (errorState) => errorState.showErrorModal
)
